"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var SortPanel_1 = __importDefault(require("../../../../../app/components/widgets/SortPanel"));
var actions_1 = __importDefault(require("../../../../actions"));
var FilterPanel_1 = __importDefault(require("./FilterPanel"));
var FilterSortPanelFooter_1 = __importDefault(require("./FilterSortPanelFooter"));
var types_1 = require("../../../../reducers/types");
var constants_1 = require("../../../../constants");
var CollapsingPanel_1 = __importDefault(require("../../../../../app/components/widgets/CollapsingPanel"));
var styles_1 = __importDefault(require("./styles"));
var sortOptions = [
    {
        label: 'Most number of visits',
        key: 'clicks',
    },
    {
        label: 'Date of creation',
        key: 'createdAt',
    },
];
var FilterSortPanel = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, tableConfig = _a.tableConfig;
    var classes = (0, styles_1.default)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var updateSortAndFilter = function (_a) {
        var title = _a.title, direction = _a.direction, state = _a.state, isFile = _a.isFile;
        dispatch(actions_1.default.setUrlTableConfig({
            orderBy: title,
            sortDirection: direction,
        }));
        dispatch(actions_1.default.setUrlFilter({
            state: state,
            isFile: isFile,
        }));
        dispatch(actions_1.default.getUrlsForUser());
    };
    var _b = __read((0, react_1.useState)(tableConfig.orderBy), 2), orderBy = _b[0], setOrderBy = _b[1];
    var _c = __read((0, react_1.useState)(tableConfig.filter.isFile === true), 2), isIncludeFiles = _c[0], setIsIncludeFiles = _c[1];
    var _d = __read((0, react_1.useState)(tableConfig.filter.isFile === false), 2), isIncludeLinks = _d[0], setIsIncludeLinks = _d[1];
    var _e = __read((0, react_1.useState)(tableConfig.filter.state === 'ACTIVE'), 2), isIncludeActive = _e[0], setIsIncludeActive = _e[1];
    var _f = __read((0, react_1.useState)(tableConfig.filter.state === 'INACTIVE'), 2), isIncludeInactive = _f[0], setIsIncludeInactive = _f[1];
    var changeSortAndFilterHandler = function () {
        var isFile;
        var state;
        if (isIncludeLinks !== isIncludeFiles) {
            if (isIncludeLinks) {
                isFile = false;
            }
            else {
                isFile = true;
            }
        }
        if (isIncludeActive !== isIncludeInactive) {
            if (isIncludeActive) {
                state = types_1.UrlState.Active;
            }
            else {
                state = types_1.UrlState.Inactive;
            }
        }
        updateSortAndFilter({
            title: orderBy,
            direction: types_1.SortDirection.Descending,
            state: state,
            isFile: isFile,
        });
        onClose();
    };
    var reset = function () {
        setIsIncludeFiles(false);
        setIsIncludeLinks(false);
        setIsIncludeActive(false);
        setIsIncludeInactive(false);
        setOrderBy(constants_1.initialSortConfig.orderBy);
        updateSortAndFilter({
            title: constants_1.initialSortConfig.orderBy,
            direction: types_1.SortDirection.Descending,
            state: undefined,
            isFile: undefined,
        });
        onClose();
    };
    return (react_1.default.createElement(CollapsingPanel_1.default, { isOpen: isOpen, onClose: onClose, className: classes.collapsingPanel },
        react_1.default.createElement(core_1.Grid, { container: true, style: {
                paddingTop: '32px',
                paddingBottom: '48px',
            } },
            react_1.default.createElement(SortPanel_1.default, { onChoose: setOrderBy, currentlyChosen: orderBy, options: sortOptions }),
            react_1.default.createElement(FilterPanel_1.default, { isIncludeFiles: isIncludeFiles, isIncludeLinks: isIncludeLinks, isIncludeActive: isIncludeActive, isIncludeInactive: isIncludeInactive, setIsIncludeFiles: setIsIncludeFiles, setIsIncludeLinks: setIsIncludeLinks, setIsIncludeActive: setIsIncludeActive, setIsIncludeInactive: setIsIncludeInactive }),
            react_1.default.createElement(FilterSortPanelFooter_1.default, { onApply: changeSortAndFilterHandler, onReset: reset }))));
};
exports.default = FilterSortPanel;
